import { Link } from "react-router-dom";
import { useApi } from "../../lib/api";
import { Reveal } from "../Reveal";
import { SectionHead } from "./SectionHead";
import { WebPickCard } from "../WebPickCard";

export const FromTheWeb = () => {
  const { data } = useApi("/from-the-web");
  const items = Array.isArray(data?.items) ? data.items.slice(0, 8) : [];
  if (!items.length) return null;
  return (
    <section className="max-w-[1440px] mx-auto px-5 sm:px-10 py-24" data-testid="from-the-web-section">
      <SectionHead kicker="Elsewhere · picked by our editors" title="From the Web" to="/from-the-web" testId="from-the-web-title" />
      <p className="font-serif italic text-xl text-ink/75 max-w-2xl -mt-6 mb-12">
        Stories we loved this month on Youth Magazine (ymagazine.com). Short notes by us, full reads on their site.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-4">
        {items.map((it, i) => (
          <Reveal key={it.url} delay={(i % 4) * 0.07} className="h-full">
            <WebPickCard item={it} index={i} testId={`web-pick-${i}`} />
          </Reveal>
        ))}
      </div>
      <Link to="/from-the-web" className="inline-flex mt-10 kicker bg-ink text-cream rounded-full px-6 py-3 border border-ink hover:bg-hot hover:text-ink transition-colors" data-testid="from-the-web-all-btn">
        All picks
      </Link>
    </section>
  );
};
